module.exports = __webpack_public_path__ + "static/fx_2.9cd256fe.jpg";